module.exports = '<svg width="27" height="32" viewBox="0 0 27 32"><path d="M16 30.667V9.376l6.453 6.245a1.394 1.394 0 0 0 1.909 0l1.912-1.824a1.253 1.253 0 0 0 0-1.824L14.255.373a1.404 1.404 0 0 0-1.912 0L.396 11.901a1.243 1.243 0 0 0 0 1.824l1.912 1.821a1.392 1.392 0 0 0 1.907 0l6.451-6.243v21.363c0 .736.597 1.333 1.333 1.333h2.667c.736 0 1.333-.597 1.333-1.333z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/up-4.js
// module id = 1470
// module chunks = 14